// extracted by mini-css-extract-plugin
module.exports = {"input":"Form_input__2ESfd","texto":"Form_texto__3xKtP","caja1":"Form_caja1__h33h1","in":"Form_in__egRjS","but":"Form_but__3_Ud4","buton":"Form_buton__2s8pM","b":"Form_b__1Ww-W"};